import factory from '../redux/api/factory';
import { Item } from '../redux/api/types';
import findItemByUuid from './find-item-by-uuid';

describe('findItemByUuid', () => {
  const items: Item[] = factory.buildList(3);

  it('should find the item by uuid', () => {
    const result = findItemByUuid(items, items[0].uuid);
    expect(result).toEqual(items[0]);
  });

  it('should return undefined if item is not found', () => {
    const result = findItemByUuid(items, 'non-existing-uuid');
    expect(result).toBeUndefined();
  });

  it('should find the item from nested children', () => {
    const result = findItemByUuid(
      items,
      items[0].customer_groups[0].customer_groups[0].uuid,
    );
    expect(result).toEqual(items[0].customer_groups[0].customer_groups[0]);
  });
});
